import React, {FC, useRef} from 'react';
import {buildStyles, CircularProgressbar} from 'react-circular-progressbar';
import {Markdown} from 'components/Markdown';
import {COLORS} from 'constants/index';

import {useTimerInView} from './useTimerInView';

import 'react-circular-progressbar/dist/styles.css';
import * as styles from './styles.module.scss';

type ChartDoughnut = {
	completed: number
	max: number
	description: string
}

const ChartDoughnut: FC<ChartDoughnut> = ({max=100, description, completed}) => {
	const ref = useRef<HTMLDivElement>(null);
	const target = Number(completed) / max * 100;
	const value = useTimerInView(ref, target);

	return (
		<div className={styles.wrapper} ref={ref}>
			<div className={styles.chart}>
				<div className={styles.inner}>
					<CircularProgressbar value={value} maxValue={max} styles={buildStyles({
						trailColor: COLORS.GRAY6,
						pathColor: COLORS.SALAD100,
						strokeLinecap: 'butt',
					})} />
				</div>
			</div>
			<div>
				<Markdown markdown={description} />
			</div>
		</div>
	);
};

export default ChartDoughnut;
